<template>
	<UpVoteIdeaButton v-if="isIdeaSavedToAccount" :idea="idea" />
	<SaveIdeaButton v-else :ideaId="idea.id" :focusIdeaOnSave="focusIdeaOnSave" />
</template>

<script>
import InspirationCenterService from './inspiration-center-service';
import SaveIdeaButton from '@/components/InspirationCenter/SaveIdeaButton.vue';
import UpVoteIdeaButton from '@/components/InspirationCenter/UpVoteIdeaButton.vue';

export default {
	name: 'IdeaMainButton',
	props: { idea: { type: Object }, focusIdeaOnSave: { type: Boolean } },
	components: { SaveIdeaButton, UpVoteIdeaButton },
	computed: {
		isIdeaSavedToAccount() {
			return InspirationCenterService.isIdeaSavedToAccount(this.idea);
		},
	},
	watch: {
		isIdeaSavedToAccount(newV) {
			if (newV) {
				// isIdeaSavedToAccount changed to true from false
				this.$emit('idea-saved');
			}
		},
	},
};
</script>
